import * as React from 'react';
import '../../../table/table.less';
import { CoreHelper, WithCoreProps } from 'ff-shared-components-core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TableColumn } from '../../../table/types';

import { Theme } from '@theme';
// import { CollapsedRow } from 'components/layout/table/tableModules/withAccordion';

export interface SecondaryRowProps {
	/**Set a row id to be used on details click */
	rowId: string;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set a suffix to the row */
	withSuffix?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/**Set headers to create sub-rows responsive appearance */
	headers?: string[];
	/**set accordion button controller */
	withAccordionButton?: boolean;
	/**set a control to the accordion */
	isAccordionOpen?: boolean;
	/**Set if the accordion is collapsed or not */
	isCollapsed?: boolean;
	// isCollapsed?: CollapsedRow;
}

export interface InjectedProps {
	theme: Theme;
}

type Props = SecondaryRowProps & RouteComponentProps & InjectedProps;

class SecondaryRowComponent extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const { columns, headers, withAccordionButton, theme, isCollapsed = false } = this.props;

		return (
			<>
				<li className={'ds-table-cell main-table-cell'}>
					{columns &&
						columns.map(
							(column: TableColumn, index: number): JSX.Element => {
								return (
									<React.Fragment key={CoreHelper.guid() || index}>
										<div
											className={`ds-table-cell-detail ${
												index + 1 === 1 ? 'ds-table-name' : ''
											} flex-column table-${index + 1 < columns.length ? 'big' : 'normal'}-cell`}
										>
											{withAccordionButton && index + 1 === 1 && (
												<div className="table-checkbox-cell">
													<img
														src={
															isCollapsed === false
																? theme.image.tabelaMostrar
																: theme.image.tabelaOcultar
														}
														alt=""
														width="24px"
														height="24px"
													/>
												</div>
											)}

											{index === 0 && <span>{column.value}</span>}

											{index + 1 > 1 && (
												<>
													<span className={'ds-table-hide'}>{headers && headers[index]}</span>
													<span>{column.value}</span>
												</>
											)}
										</div>

										{index + 1 === columns.length && (
											<div className="ds-table-cell-detail flex-column table-small-cell"></div>
										)}
									</React.Fragment>
								);
							}
						)}
				</li>
			</>
		);
	}
}

export const SecondaryRow = WithCoreProps<SecondaryRowProps>(withRouter(SecondaryRowComponent));
